import { useState, useEffect } from 'react';
import { Row, Col, Tab, Tabs } from 'react-bootstrap';
import WaysOfRegistrationTab from './WaysOfRegistrationTab';
import { ClaimDetailsSVG } from '../../../img/GlobalSVG';

const WaysOfRegistration = (props) => {
  const { onChange, hasEditPermission } = props;
  const { values, errorValidation } = props;
  const { waysOfRegistrationEditable } = props;
  const [memberKey, setMemberKey] = useState('For Member');

  useEffect(() => {
    if (values.allowMember === true) {
      setMemberKey('For Member');
    } else {
      setMemberKey('For Dependent');
    }
  }, [values]);

  return (
    <Row className="Payment-details ways-of-registration">
      <Col className="pl-0">
        <h3
          className={
            errorValidation.waysOfRegMember ||
            errorValidation.waysOfRegDependent
              ? 'errorValidate'
              : ''
          }
        >
          Ways of Registration
        </h3>
        <p className="mb-2">
          Define the various way in which Members or Dependents can register
          themselves to the portal.
        </p>
        {(errorValidation.waysOfRegMember ||
          errorValidation.waysOfRegDependent) && (
          <div className="d-flex align-items-center">
            <ClaimDetailsSVG.ExclamationSVG />
            <p className="errorMessage ml-2">
              Select at least 1 way in which a Member or Dependent can register.
            </p>
          </div>
        )}
      </Col>
      <Col className="setup-form">
        {(values.allowDependent || values.allowMember) && (
          <Tabs
            activeKey={memberKey}
            onSelect={(k) => setMemberKey(k)}
            id="uncontrolled-tab-example"
            className={`${
              errorValidation.waysOfRegMember && 'errorValidateForMember'
            }
                  ${
                    errorValidation.waysOfRegDependent &&
                    'errorValidateForDependent'
                  }`}
          >
            {values.allowMember && (
              <Tab eventKey="For Member" title="For Member">
                <WaysOfRegistrationTab
                  iIndex={0}
                  waysOfRegistrationEditable={waysOfRegistrationEditable}
                  onChange={onChange}
                  handleWaysOfReg={props.handleWaysOfReg}
                  hasEditPermission={hasEditPermission}
                />
              </Tab>
            )}
            {values.allowDependent && (
              <Tab eventKey="For Dependent" title="For Dependent">
                <WaysOfRegistrationTab
                  iIndex={3}
                  waysOfRegistrationEditable={waysOfRegistrationEditable}
                  onChange={onChange}
                  handleWaysOfReg={props.handleWaysOfReg}
                  hasEditPermission={hasEditPermission}
                />
              </Tab>
            )}
          </Tabs>
        )}
        {!values.allowDependent && !values.allowMember && (
          <p className="mt-4">
            Member and Dependent are not allowed to register.
          </p>
        )}
      </Col>
    </Row>
  );
};

export default WaysOfRegistration;
